import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { Burner } from '../../models';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { MatCheckbox } from '@angular/material/checkbox';
import { RootState } from '../../root-store/root.state';
import { seSetBurnDevice } from '../../search-page/redux/search-page.actions';
import { SearchFormType } from '../../search-page/search-page-type.enum';

export interface BurnDeviceData {
    devicesList: Burner[];
    selectedDevice?: Burner;
}

@Component({
    selector: 'se-assign-burn-device-dialog',
    standalone: true,
    templateUrl: './se-assign-burn-device-dialog.component.html',
    styleUrl: './se-assign-burn-device-dialog.component.scss',
    providers: [MatDialogConfig],
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        TranslateModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckbox,
    ],
})
export class SeAssignBurnDeviceDialogComponent implements OnInit {
    selectedDevice: Burner | null = null;
    selectedDeviceControl = new FormControl<Burner | null>(null);
    _defaultChecked: boolean = true;
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            devicesList: Burner[];
            selectedDevice: Burner;
        },
        private store: Store<RootState>,
    ) {}

    ngOnInit(): void {
        this.selectedDevice = this.data.selectedDevice;
        this.setSelectedDevice();
    }

    private setSelectedDevice() {
        if (this.data.devicesList.length > 0 && this.selectedDevice !== null) {
            let deviceToSelect = this.data.devicesList.find((el) => el.ipAddress == this.selectedDevice?.ipAddress);
            if (deviceToSelect) {
                this.selectedDeviceControl.setValue(deviceToSelect);
            }
        }
    }

    _onConfirm() {
        this.selectedDevice = this.selectedDeviceControl.value;
        if (this.selectedDevice && this._defaultChecked) {
            // setto il valore del masterizzatore scelto nello store
            this.store.dispatch(
                seSetBurnDevice({
                    formType: SearchFormType.SPECIALTY,
                    device: this.selectedDevice,
                }),
            );
        } else {
            this.selectedDevice = null;
            this.store.dispatch(
                seSetBurnDevice({
                    formType: SearchFormType.SPECIALTY,
                    device: this.selectedDevice,
                }),
            );
        }
    }

    _onDefaultCheckedChange() {
        this._defaultChecked = !this._defaultChecked;
    }

    _setDialogOutputValues() {
        return {
            device: this.selectedDeviceControl.value,
            isDefault: this._defaultChecked,
        };
    }
}
